import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';


function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}
const data = {
  "Automated Vendor Receipts": {
    image: require("../../src/assets/images/website/bpharm2.jpg"),
    description: "Simplify inventory tracking with digital purchase receipts.",
  },
  "Proactive Expiration Alerts": {
    image: require("../../src/assets/images/website/bpharm3.jpg"),
    description: "Manage inventory efficiently with automated expired drug reports.",
  },
  "Effortless GST Billing": {
    image: require("../../src/assets/images/website/bpharm4.jpg"),
    description: "Automate tax calculations for accurate and efficient financial management.",
  },
  "Tailored Discount Programs": {
    image: require("../../src/assets/images/website/bpharm5.jpg"),
    description: "Enhance customer loyalty with flexible medicine billing discounts.",
  },
  "Complete Digital Pharmacy Solution": {
    image: require("../../src/assets/images/website/bpharm6.jpg"),
    description: "Optimize every aspect of your operations with our comprehensive suite of digital tools.",
  },
};

class BenifitsPharmacy extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            currentImage: data["Complete Digital Pharmacy Solution"].image, // Default image
      hoveredText: "",
  
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    handleHover = (title) => {
      this.setState({
        hoveredText: data[title].description,
        currentImage: data[title].image, // Ensure image updates dynamically
      });
    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        
        return (
            <div className="">

                <div className="">
                    {/* <section className="my-head"> */}
                        {/* <div className="container-fluid">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessHeader user_id={this.props.userdata.id} />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserHeader user_id={this.props.userdata.id} />
                            ) : (
                                <Header user_id={this.props.userdata.id} />
                            )}
                        </div> */}
                    {/* </section> */}
                    <div className="">
                        {/* <div className="sidemenu ">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessUserSideBar />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserSideBar />
                            ) : (
                                <ClientSideBar />
                            )}
                        </div> */}

                        {/* <section className="main-body hospital-profilegap "> */}
                            {/* <IdleTimeOutModal
                                showModal={this.state.showModal}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            /> */}

                            {/* <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={hospitaltimeout} /> */}

                            {/* <div className="container-fluid checkout-tabs"> */}
                                {/* <IdleTimeOutModal
                                    showModal={this.state.showModal}
                                    handleClose={this.handleClose}
                                    handleLogout={this.handleLogout}
                                /> */}

                                {/* <IdleTimer
                                    ref={ref => { this.idleTimer = ref }}
                                    element={document}
                                    onActive={this.onActive}
                                    onIdle={this.onIdle}
                                    onAction={this.onAction}
                                    debounce={250}
                                    timeout={hospitaltimeout} /> */}

<div className='product-section'>
    <Headerweb/>
  
    
 
            <hr className='m-0' style={{ color: '#D9F4FF' }} />
            <section className='pt-5'>
           
            <div className='' id='increase_revenue' style={{ marginTop: '50px', position: 'relative' }}>
    <div className='background-image' style={{ backgroundImage: `url(${require("../../src/assets/images/website/396.jpg")})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '500px', position: 'relative' }}>
        <div className='overlay-text' style={{ position: 'absolute', left: '10%', top: '50%', transform: 'translateY(-50%)', color: '#fff' }}>
            <h1>Benefits For Pharmacy</h1>
            <p>Your Pharmacy's Efficiency & Service</p>
        </div>
    </div>
</div>      {/* <div className=''>
                <div className='' id='increase_productivity' style={{ marginTop: '50px' }}>
    <div className='row m-0'>
        <div className='col-12'>
            <img src={require("../../src/assets/images/website/249.jpg")} className='w-100 h-auto' alt="Increase Productivity" />
        </div>
    </div>
</div>
</div> */}
<div className="row justify-content-center text-center mt-5">
<h1>
      Empowering Care at Your <span className="balance-move">Pharmacy</span>
    </h1>
  </div>
  

<div class="pharmacy-container">
    {/* First Row */}
    <div class="row-section">
        <div class="benefit-box">
            <div class="box-left">
                <img src={require("../../src/assets/images/website/feature-1.png")} alt="Icon"/>
            </div>
            <div class="box-right">
                <h3>Instant Digital Prescriptions</h3>
                <p>Receive prescriptions directly from physicians, eliminating errors and accelerating dispensing.</p>
            </div>
        </div>
        <div class="benefit-box">
            <div class="box-left">
                <img src={require("../../src/assets/images/website/feature-2.png")} alt="Icon"/>
            </div>
            <div class="box-right">
                <h3>Rapid Medicine Dispensing</h3>
                <p>Deliver faster, more accurate service with our streamlined dispensing process.</p>
            </div>
        </div>
    </div>

    {/* Second Row */}
    <div class="row-section">
        <div class="benefit-box">
            <div class="box-left">
                <img src={require("../../src/assets/images/website/feature-3.png")} alt="Icon"/>
            </div>
            <div class="box-right">
                <h3>Real-Time Stock Management</h3>
                <p>Track inventory effortlessly with automated stock reports.</p>
            </div>
        </div>
        <div class="benefit-box">
            <div class="box-left">
                <img src={require("../../src/assets/images/website/feature-4.png")} alt="Icon"/>
            </div>
            <div class="box-right">
                <h3>Minimize Waste, Maximize Profit</h3>
                <p>Implement FEFO management to prevent drug obsolescence.</p>
            </div>
        </div>
    </div>
</div>

<div className="container-90">
<div className="row justify-content-center text-center mb-5">
<h1>
Revolutionizing Pharmacy Workflow with Digital Solutions
    </h1>
  </div>
        
        <div className="wrapper2">
          <div className="info-section">
            {Object.keys(data).map((title) => (
              <div
                key={title}
                className="text-box"
                onMouseEnter={() => this.handleHover(title)}
              >
                <h3>{title}</h3>
                <p className="dynamic-text">{this.state.hoveredText}</p>
              </div>
            ))}
          </div>
          <div className="visual-section">
            <img src={this.state.currentImage} alt="Dynamic Display" />
          </div>
        </div>
      </div>


  {/* <div className="wrapper">
                <div className="info-section">
                    <div className="text-box">
                        <h3>Automated Vendor Receipts</h3>
                        <p className="hidden-text">Simplify inventory tracking with digital purchase receipts.</p>
                    </div>
                    <div className="text-box">
                        <h3>Proactive Expiration Alerts</h3>
                        <p className="hidden-text">Manage inventory efficiently with automated expired drug reports.</p>
                    </div>
                    <div className="text-box">
                        <h3>Effortless GST Billing</h3>
                        <p className="hidden-text">Automate tax calculations for accurate and efficient financial management.</p>
                    </div>
                    <div className="text-box">
                        <h3>Tailored Discount Programs</h3>
                        <p className="hidden-text">Enhance customer loyalty with flexible medicine billing discounts.</p>
                    </div>
                    <div className="text-box">
                        <h3>Complete Digital Pharmacy Solution</h3>
                        <p className="hidden-text">Optimize every aspect of your operations with our comprehensive suite of digital tools.</p>
                    </div>
                </div>
                <div className="visual-section">
                    <img src={require("../../src/assets/images/website/234.png")} alt="Digital Pharmacy Solution" />
                </div>
            </div> */}

            

            {/* <div className="wrapper">
        <div className="info-section">
          {data.map((item, index) => (
            <div
              key={index}
              className="text-box"
              onMouseEnter={() => this.handleMouseEnter(index)}
              onMouseLeave={this.handleMouseLeave}
            >
              <h3>{item.title}</h3>
              <p className={this.state.activeBoxIndex === index ? "show" : "hidden"}>{item.text}</p>
            </div>
          ))}
        </div>
        <div className="visual-section">
          <img src={this.state.imageSrc} alt="Dynamic Display" />
        </div>
      </div> */}

<div className="background-container">
                  <div className="custom-row">
                    {/* Left Column: Content */}
                    <div className="custom-col content-section">
                      <h1>Book Your Personalized Demo</h1>
                      <p>
                        Now explore how our advanced tools can revolutionize
                        Nucleo healthcare operations. Schedule a demo with our
                        team and unlock the full potential of innovation in
                        healthcare.
                      </p>
                      <a href="/Webcontact" className="book-demo-btn">
                        Book Demo
                      </a>
                    </div>

                    {/* Right Column: Image */}
                    <div className="custom-col image-section">
                      <img
                        src={require("../../src/assets/images/website/234.webp")}
                        alt="Healthcare Innovation"
                      />
                    </div>
                  </div>
                </div>


              
            </section>
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
    componentDidMount = () => {
       /*  console.log(this.props.userdata.user_type);
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                console.log(res);
                console.log(data);
                console.log(data.data.timeout);
                if (data.status === "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout

                    });
            })
            .catch((e) => { }); */
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(BenifitsPharmacy);